import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,

  // Adds request headers and IP for users
  sendDefaultPii: true,

  environment: import.meta.env.VITE_ENVIRONMENT || "development",

  integrations: [
    // Performance monitoring with React Router support
    Sentry.browserTracingIntegration(),

    // Session replay for debugging
    Sentry.replayIntegration({
      // Mask all text and inputs for privacy
      maskAllText: true,
      maskAllInputs: true,
      // Block all media for privacy and performance
      blockAllMedia: true,
    }),

    // User feedback widget
    Sentry.feedbackIntegration({
      colorScheme: "system",
      showBranding: false,
    }),

    // Console logging integration
    Sentry.consoleLoggingIntegration({
      levels: ["error", "warn"],
    }),
  ],

  // Enable experimental logging
  _experiments: {
    enableLogs: true,
  },

  // Performance monitoring - capture 100% in dev, 10% in production
  tracesSampleRate:
    import.meta.env.VITE_ENVIRONMENT === "production" ? 0.1 : 1.0,

  // // Set trace propagation targets for your backend
  // tracePropagationTargets: [
  //   /^\/api/,
  //   // Add your backend domains here when you have them
  //   // /^https:\/\/your-backend\.com\/api/,
  // ],

  // Session Replay sampling
  // Capture 10% of all sessions, plus 100% of sessions with errors
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,

  // // Filter out development/testing errors
  // beforeSend(event) {
  //   // Don't send events in development from localhost
  //   // && event.request?.url?.includes("localhost")
  //   if (import.meta.env.VITE_ENVIRONMENT === "development") {
  //     return null;
  //   }
  //   return event;
  // },

  // Set user context
  initialScope: {
    tags: {
      component: "gpsbox-portal",
    },
  },
});

// Export logger for use throughout the app
export const { logger } = Sentry;
